import React from "react";

// Simplified variants to ensure valid paths and avoid rendering issues
const cloudConfigs: Record<number, { path: string; viewBox: string }> = {
    // 1: Material Design standard cloud
    1: {
        path: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z",
        viewBox: "0 2 24 20"
    },
    // 2: Phosphor solid cloud
    2: {
        path: "M72,216H184a64,64,0,0,0,29.9-120.7,96,96,0,0,0-165.7-18.7A56,56,0,0,0,72,216Z",
        viewBox: "0 30 256 190"
    },
    // 3: FontAwesome solid cloud
    3: {
        path: "M0 336c0 53 43 96 96 96h320c61.9 0 112-50.1 112-112c0-57.1-42.6-104-97.1-111.9c-8.5-62.8-62.3-112.1-126.9-112.1c-53.7 0-100.3 32.8-119.5 80.8c-10.4-3.6-21.7-5.6-33.5-5.6c-53 0-96 43-96 96c0 14.4 3.2 28.1 9 40.5C22.7 308.5 0 318.5 0 336z",
        viewBox: "0 100 528 335"
    },
    // 4: Bootstrap solid cloud
    4: {
        path: "M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z",
        viewBox: "0 2 16 11"
    }
};

interface VectorCloudProps extends React.SVGProps<SVGSVGElement> {
    variant?: number;
}

const VectorCloud = ({ variant = 1, ...props }: VectorCloudProps) => {
    const config = cloudConfigs[variant] || cloudConfigs[1]!;
    const { path: pathData, viewBox } = config;
    const clipId = `cloud-clip-${variant}`;

    return (
        <svg
            viewBox={viewBox}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            style={{
                ...props.style,
                clipPath: `url(#${clipId})`,
                WebkitClipPath: `url(#${clipId})`
            }}
        >
            <defs>
                <clipPath id={clipId}>
                    <path d={pathData} />
                </clipPath>
            </defs>
            <path
                d={pathData}
                fill="#FFFFFF"
                fillOpacity="0.8"
            />
        </svg>
    );
};

export default VectorCloud;

